import React from 'react';
import { Spinner, Container } from 'react-bootstrap';

function Loading({ message = 'Carregando...' }) {
  return (
    <Container className="text-center mt-5">
      <Spinner animation="border" role="status" className="mb-3">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <div>{message}</div>
    </Container>
  );
}

export default Loading;